"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllowedSignatureTypesToJSON = exports.AllowedSignatureTypesFromJSONTyped = exports.AllowedSignatureTypesFromJSON = exports.instanceOfAllowedSignatureTypes = exports.attributeTypeMapAllowedSignatureTypes = void 0;
exports.attributeTypeMapAllowedSignatureTypes = [
    {
        name: "C",
        type: "boolean",
    },
    {
        name: "T",
        type: "boolean",
    },
    {
        name: "U",
        type: "boolean",
    },
    {
        name: "E",
        type: "boolean",
    },
    {
        name: "S",
        type: "boolean",
    },
    {
        name: "ERROR",
        type: "boolean",
    },
];
/**
 * Check if a given object implements the AllowedSignatureTypes interface.
 */
function instanceOfAllowedSignatureTypes(value) {
    if (!("c" in value) || value["C"] === undefined)
        return false;
    if (!("t" in value) || value["T"] === undefined)
        return false;
    if (!("u" in value) || value["U"] === undefined)
        return false;
    if (!("e" in value) || value["E"] === undefined)
        return false;
    if (!("s" in value) || value["S"] === undefined)
        return false;
    if (!("eRROR" in value) || value["ERROR"] === undefined)
        return false;
    return true;
}
exports.instanceOfAllowedSignatureTypes = instanceOfAllowedSignatureTypes;
function AllowedSignatureTypesFromJSON(json) {
    return AllowedSignatureTypesFromJSONTyped(json, false);
}
exports.AllowedSignatureTypesFromJSON = AllowedSignatureTypesFromJSON;
function AllowedSignatureTypesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        C: json["C"],
        T: json["T"],
        U: json["U"],
        E: json["E"],
        S: json["S"],
        ERROR: json["ERROR"],
    };
}
exports.AllowedSignatureTypesFromJSONTyped = AllowedSignatureTypesFromJSONTyped;
function AllowedSignatureTypesToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        C: value["C"],
        T: value["T"],
        U: value["U"],
        E: value["E"],
        S: value["S"],
        ERROR: value["ERROR"],
    };
}
exports.AllowedSignatureTypesToJSON = AllowedSignatureTypesToJSON;
